<template>
  <div>
    <EventBus
      @onOpenTipsCrx="onOpenTipsCrx"
    />
    <div v-if="showTipsCrx">
      <div class="overlay" />
      <div class="tipsContent">
        <img src="../images/TipsCrx1.png">
        <v-layout class="mt-4">
          <v-spacer />
          <div>
            <img src="../images/TipsCrx2.png">
          </div>
          <div class="text-xs-center ml-4">
            <v-progress-circular
              :rotate="360"
              :size="80"
              :width="5"
              :value="progressValue"
              color="#ffcc4e"
            >
              <span
                style="font-size:45px;"
                class="white--text"
              >
                {{ secTime }}
              </span>
            </v-progress-circular>
          </div>
          <v-spacer />
        </v-layout>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllCrx } from '@/utils/crxSDK'

export default {
  data () {
    return {
      secTime: 5,
      checkCount: 0,
      showTipsCrx: false,
    }
  },
  computed: {
    progressValue () {
      return (5 - this.secTime) / 5 * 100
    },
    isChrome () {
      return this.$store.state.isChrome
    },
    installedCrx: {
      get () {
        return this.$store.state.installedCrx
      },
      set (value) {
        this.$store.commit('setInstalledCrx', value)
      }
    },
    user () {
      return this.$store.state.userData
    },
  },
  watch: {
    user () {
      if (this.user.uid) {
        if (this.installedCrx) {
          this.checkShopback()
        }
      }
    },
  },
  mounted () {
    if (this.isChrome) {
      this.checkInstallCrx()
      this.checkTimer = setInterval(async () => {
        this.checkInstallCrx()
      }, 5000)

      if (!this.noWatchMessage) {
        window.addEventListener('message', this.handerMessage)
      }
    }
  },
  methods: {
    async checkInstallCrx () {
      console.log('checkInstallCrx')
      this.checkCount++
      if (await this.$store.dispatch('checkInstallCrx')) {
        if (this.checkCount > 1 && !this.installedCrx) {
          location.reload()
        }
        this.installedCrx = true
      } else {
        this.installedCrx = false
        clearInterval(this.checkTimer)
        this.onOpenTipsCrx()
      }
    },
    onOpenTipsCrx () {
      if (!this.showTipsCrx && localStorage.loginCount > 1) {
        this.showTipsCrx = true
        this.secTime = 5
        setTimeout(() => {
          const timer = setInterval(() => {
            this.secTime -= 1
            if (this.secTime <= 0) {
              clearInterval(timer)
              setTimeout(() => {
                this.showTipsCrx = false
                // this.$router.push({name: 'NoLoginHome', params: {showTipsCrx: 1}})
              }, 1000)
            }
          }, 1000)
        }, 100)
      }
    },
    async checkShopback () {
      if (localStorage.checkedShopback) {
        return
      }
      const list = await getAllCrx()
      const installed = !!list?.find(item => item.id === 'djjjmdgomejlopjnccoejdhgjmiappap')
      const res = await await this.$store.dispatch('user/usermbr/updateSettings', {
        hasShopbackCrx: installed ? '1' : '0',
      })
      if (!res.data.error) {
        localStorage.checkedShopback = '1'
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
.overlay {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 21;
}

.tipsContent {
  position: fixed;
  z-index: 21;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 700px
}
</style>
